import { Component, ViewEncapsulation } from '@angular/core';
import { AfterContentInit, Input } from '@angular/core';

type Field = HTMLElement & {schema: any};

@Component({
    selector: 'hub-register-form',
    templateUrl: 'hub-register-form.component.html',
    styleUrls: ['hub-register-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class HubRegisterFormComponent implements AfterContentInit {

    @Input() public submitLabel: string = 'Continuar';

    public isValidForm: boolean = false;
    public pendingSubmit: boolean = false;
    private toroForms = (document as any).toroForms;
    private form: HTMLFormElement = null;

    public ngAfterContentInit() {

        // Registra o formulário do tipo toro-form
        this.toroForms.registerForms();

        // Aramazena o formulário registrado
        this.form = this.toroForms.registeredForms[0];

    }

    /**
     * Verifica se um input é válido
     *
     * @param fieldId
     */
    public isValidField(fieldId: string) {

        if (!this.form) return true;

        const field: Field = this.form.querySelector(`[data-field="${fieldId}"]`) as Field;
        return field.schema.valid || !field.schema.errors.length;
    }

    /**
     * Método a ser executado ao submeter o form
     */
    public submitRegister() {
        this.form.addEventListener('submit', () => this.pendingSubmit = this.form.valid);
        this.form.addEventListener('submitError', () => this.pendingSubmit = false);
    }

}
